const apiUrl = process.env.REACT_APP_API_URL;
export const GetPracticaUsuarisEnviaments = async (id_practica: string, id_usuari: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${id_practica}/usuaris/${id_usuari}/enviaments`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            console.log(await response.text());
            return [];
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};
